export const API_URL = process.env.REACT_APP_API_URL || "https://trustedgeapi.tecnospice.com/"
// export const API_URL = "https://trustedgeapi.tecnospice.com/"
// Fallback order: REACT_APP_API_URL env var → local dev server

// Build-version handshake. Unauthenticated and polled by every open tab: the
// number the server publishes here is the build a browser is expected to be
// running, and a tab that doesn't match is running code we already replaced.
export const APP_VERSION_URL = 'app-version/'
export const APP_VERSION_PUBLISH_URL = 'app-version/publish/'

// ── Admin / Onboarding portal endpoints ──────────────────────────────────────
export const ADMIN_LOGIN_URL = 'admin-portal/login/'
export const ADMIN_TENANTS_URL = 'admin-portal/tenants/'
export const ADMIN_TENANT_URL = (id) => `admin-portal/tenants/${id}/`
export const ADMIN_OVERRIDES_URL = (id) => `admin-portal/tenants/${id}/overrides/`
export const ADMIN_PLANS_URL = 'admin-portal/plans/'

// authentication endpoints
export const LOGIN_URL = `auth/user/login/`;
export const CREATE_LOGIN_USER_URL = `auth/login/create/`;
export const LOGOUT_URL = `auth/logout/`;

// customer list
export const CUSTOMERSLIST = 'customer/get/'
// Every state the user's leads carry, with counts — the reports' State filter.
export const LEAD_STATES_URL = 'customer/states/'
export const CUSTOMERCREATE = 'customer/create/'
export const CUSTOMERBULKUPLOAD = 'customer/bulk/upload/'
// Duplicate leads — trustedge customers/dedupe.py
export const DEDUPE_CHECK_URL = 'customer/dedupe/check/'
export const DEDUPE_ATTACH_URL = 'customer/dedupe/attach/'
export const DEDUPE_CONFIG_URL = 'customer/dedupe/config/'
export const LEAD_PRIORITY_CONFIG_URL = 'customer/lead-priority/config/'
export const DEDUPE_GROUPS_URL = 'customer/dedupe/groups/'
export const DEDUPE_MERGE_URL = 'customer/dedupe/merge/'
export const LEAD_ENQUIRIES_URL = 'customer/enquiries/'
// Lead assignment engine — trustedge customers/assignment/
export const ASSIGNMENT_SETTINGS_URL = 'customer/assignment/settings/'
export const ASSIGNMENT_FIELDS_URL = 'customer/assignment/fields/'
export const ASSIGNMENT_RULES_URL = 'customer/assignment/rules/'
export const ASSIGNMENT_RULES_ORDER_URL = 'customer/assignment/rules/order/'
export const ASSIGNMENT_SIMULATE_URL = 'customer/assignment/simulate/'
export const ASSIGNMENT_TEAMS_URL = 'customer/assignment/teams/'
export const ASSIGNMENT_CAPACITY_URL = 'customer/assignment/capacity/'
export const ASSIGNMENT_ASSIGN_URL = 'customer/assignment/assign/'
export const ASSIGNMENT_RETRY_URL = 'customer/assignment/retry/'
export const ASSIGNMENT_CLAIM_URL = 'customer/assignment/claim/'
export const ASSIGNMENT_UNASSIGNED_URL = 'customer/assignment/unassigned/'
export const ASSIGNMENT_HISTORY_URL = 'customer/assignment/history/'
export const ASSIGNMENT_SUMMARY_URL = 'customer/assignment/summary/'
export const CUSTOMERDETAILSUPDATE = 'customer/details/update/'
export const CUSTOMERLOG = 'customer/status/log/'
export const CUSTOMERLOG_EDIT = (id) => `customer/status/log/${id}/`

//funnel category for customer
export const CUSTOMERSETCATEGORY = 'customer/set-category/'

// customer type master
export const CUSTOMER_TYPE_MASTER_URL = 'customer/type/'
// Channel-partner sourcing: which partner a lead came from, and what became of
// the leads each one sent.
export const CHANNEL_PARTNER_OPTIONS_URL = 'customer/channel-partners/options/'
export const CHANNEL_PARTNER_SOURCED_LEADS_URL = 'customer/channel-partners/sourced-leads/'
// Rewards this customer earned for referring other hospitals. Decided here;
// the panel is read-only because awards are granted on the Referral Rewards
// screen, which has the selection and totals that make them sensible.
export const CUSTOMER_REFERRAL_REWARDS_URL = 'customer/referrals/rewards/'
// Referral programme administration. The rates and terms are tenant-wide, so
// they live in Settings; awarding belongs beside the customers it concerns.
export const REFERRAL_SETTINGS_URL = 'customer/referrals/settings/'
export const REFERRAL_TERMS_URL = 'customer/referrals/terms/'
export const REFERRAL_AWARDABLE_URL = 'customer/referrals/awardable/'
export const REFERRAL_REWARDS_MANAGE_URL = 'customer/referrals/rewards/manage/'
// + <id>/ for a status transition
export const REFERRAL_REWARDS_URL = 'customer/referrals/rewards/'
// Both directions of the eMedHub sync, from the one side that can see them.
export const REFERRAL_SYNC_STATUS_URL = 'customer/referrals/sync-status/'
export const CHANNEL_PARTNER_REPORT_URL = 'customer/channel-partners/performance/report/'

//funner category list
export const CATEGORYLIST = 'customer/funnel/'

//assigned to user
export const ASSIGNEDTOUSER = 'customer/new-assign/'

//customer name query
export const CUSTOMERSNAMEQUERY = 'customer/search/?query='

// follow up
export const CUSTOMERDAILYFOLLOWUPLIST = 'customer/daily/followup/list/'

// engagement score
export const CUSTOMER_ENGAGEMENT_URL = 'customer/engagement/'
export const CUSTOMER_ENGAGEMENT_REPORT_URL = 'customer/engagement/report/'
export const DASHBOARD_ENGAGEMENT_URL = 'dashboard/engagement/'

// conversion analytics
export const CONVERSION_ANALYTICS_URL = 'customer/conversion/report/analytics/'

// user list
export const USERSLIST_URL = 'auth/login/create/'
export const USERCREATE = 'auth/login/create/'

// reports
export const CUSTOMERSTATUSREPORTS = 'customer/status/log/Report/'
// AI next-action suggestions + daily manager briefing
// (written by `manage.py generate_lead_suggestions`)
export const AI_SUGGESTIONS_URL = 'customer/ai/suggestions/'
export const AI_SUGGESTION_UPDATE = (id) => `customer/ai/suggestions/${id}/`
export const AI_BRIEFING_URL = 'customer/ai/briefing/'
// Sales team performance — one row per rep, with monthly targets vs actuals
export const TEAM_PERFORMANCE_URL = 'customer/team/performance/report/'
export const TEAM_TARGETS_URL = 'customer/team/targets/'
// Dynamic customer attributes — admin-defined fields per customer type
export const ATTRIBUTES_URL = 'customer/attributes/'
export const ATTRIBUTE_DETAIL = (id) => `customer/attributes/${id}/`
export const ATTRIBUTE_REORDER_URL = 'customer/attributes/reorder/'
export const ATTRIBUTE_ASSIGNMENTS_URL = 'customer/attributes/assignments/'
export const ATTRIBUTE_VALUES_URL = 'customer/attributes/values/'
// Demo desk (no-show prevention) + win/loss coaching
export const DEMO_CONFIRMATIONS_URL = 'customer/demos/confirmations/'
export const DEMO_CONFIRMATION_UPDATE = (id) => `customer/demos/confirmations/${id}/`
export const COACHING_INSIGHTS_URL = 'customer/coaching/insights/'
// Analytical landing page for notification clicks
export const ACTION_CENTER_URL = 'customer/alerts/action-center/'
export const CUSTOMERLEADSOURCEREPORT = 'customer/lead/source/report/'
export const META_PERFORMANCE_REPORT_URL = 'customer/meta/performance/report/'
export const CUSTOMERLEADTYPEREPORT = 'customer/lead/type/report/'
export const LEAD_STAGE_REPORT_URL = 'customer/lead/stage/report/'
export const CUSTOMERLEADPOTENTIALREPORT = 'customer/lead/potential/report/'
export const PIPELINE_ACTIVITY_REPORT_URL = 'customer/pipeline/activity/report/'
export const DEMO_CALENDAR_URL = 'customer/demos/calendar/'
export const LEADFORMLIST = 'customer/lead/form/'

// dashboard
export const DASHBOARD_SUMMARY = 'dashboard/summary/'
export const DASHBOARD_MY = 'dashboard/my/'
export const DASHBOARD_TEAM_TODAY = 'dashboard/team-today/'
export const DASHBOARD_TEAM_NUDGE = 'dashboard/team-today/nudge/'
export const SALES_FORECAST_URL = 'dashboard/forecast/'
export const FORECAST_CONFIG_URL = 'dashboard/forecast/config/'
export const PROJECTIONS_URL = 'dashboard/projections/'
export const PROJECTIONS_SUMMARY_URL = 'dashboard/projections/summary/'

// notifications
export const NOTIFICATIONS_URL = 'notifications/'
export const NOTIFICATIONS_UNREAD_COUNT_URL = 'notifications/unread-count/'

// tasks
export const TASKS_URL = 'tasks/'

// roles
export const ROLES_URL = 'auth/roles/'

// projects
export const PROJECTS_URL = 'auth/projects/'
export const PROJECT_MEMBERS_URL = 'auth/projects/members/'
// tenant-wide switch: may a lead's project be picked on the customer form
export const PROJECT_ASSIGNMENT_CONFIG_URL = 'customer/project-assignment/config/'

// simple users list for dropdowns (no users.view permission required)
export const USERS_SIMPLE_URL = 'auth/users/simple/'

// email integration
export const EMAIL_ACCOUNTS_URL = 'email/accounts/'
export const EMAIL_PROVIDERS_URL = 'email/accounts/providers/'
export const EMAIL_GMAIL_OAUTH_URL = 'email/accounts/oauth/gmail/'
export const EMAIL_OUTLOOK_OAUTH_URL = 'email/accounts/oauth/outlook/'
export const EMAIL_SEND_URL = 'email/send/'
export const EMAIL_MESSAGES_URL = 'email/messages/'
export const EMAIL_TEMPLATES_URL = 'email/templates/'
export const EMAIL_ANALYTICS_URL = 'email/analytics/'
export const EMAIL_IMAGES_URL = 'email/images/'
export const EMAIL_PREVIEW_URL = 'email/preview/'
export const EMAIL_SENDING_POOL_URL = 'email/sending-pool/'
export const EMAIL_ACCOUNT_VERIFY_SMTP_URL = (id) => `email/accounts/${id}/verify-smtp/`
// Manual inbox sync — nothing syncs on a schedule.
export const EMAIL_ACCOUNT_SYNC_URL = (id) => `email/accounts/${id}/sync/`
export const EMAIL_CUSTOMER_SYNC_URL = (customerId) => `email/sync/customer/${customerId}/`
export const EMAIL_CAMPAIGNS_URL = 'email/campaigns/'
export const EMAIL_CAMPAIGN_AUDIENCE_URL = 'email/campaigns/audience-preview/'
export const EMAIL_CAMPAIGN_START_URL = (id) => `email/campaigns/${id}/start/`
export const EMAIL_CAMPAIGN_RECIPIENTS_URL = (id) => `email/campaigns/${id}/recipients/`
// New lead welcome email — switch, template, sender; and what it did lately.
export const EMAIL_LEAD_WELCOME_URL = 'email/lead-welcome/'
export const EMAIL_LEAD_WELCOME_LOG_URL = 'email/lead-welcome/log/'
export const EMAIL_LEAD_WELCOME_REPORT_URL = 'email/lead-welcome/report/'
// Verified email / mobile badges on a lead's contacts (confirm-details link).
export const CONTACT_VERIFICATION_URL = (customerId) => `email/contact-verification/${customerId}/`
// Demo slots the lead chose on the website's confirm-details page.
export const DEMO_PREFERENCE_URL = (customerId) => `email/demo-preference/${customerId}/`
// Demo feedback request after Demo Done — settings, what it did lately, one lead's answers.
export const DEMO_FEEDBACK_URL = 'email/demo-feedback/'
export const DEMO_FEEDBACK_LOG_URL = 'email/demo-feedback/log/'
export const LEAD_DEMO_FEEDBACK_URL = (customerId) => `email/demo-feedback/lead/${customerId}/`
export const DEMO_REMINDER_URL = 'email/demo-reminder/'
export const DEMO_REMINDER_LOG_URL = 'email/demo-reminder/log/'
export const LEAD_DEMO_REMINDER_URL = (customerId) => `email/demo-reminder/lead/${customerId}/`
export const DEMO_REPORT_URL = 'email/demo-report/'
// Lead nurture while a lead is parked in the Nurture stage (nurture.py).
export const NURTURE_URL = 'email/nurture/'
export const NURTURE_LOG_URL = 'email/nurture/log/'
export const LEAD_NURTURE_URL = (customerId) => `email/nurture/lead/${customerId}/`
export const NURTURE_REPORT_URL = 'email/nurture/report/'
// Who takes the demo: the status form's "Demo by" (default presenter, can reps choose).
export const DEMO_PRESENTER_URL = 'email/demo-presenter/'

// whatsapp integration
export const WA_ACCOUNTS_URL = 'whatsapp/accounts/'
export const WA_SEND_URL = 'whatsapp/send/'
export const WA_MESSAGES_URL = 'whatsapp/messages/'
export const WA_LEAD_FIELDS_URL = 'whatsapp/lead-fields/'
export const WA_TEMPLATES_URL = 'whatsapp/templates/'
export const WA_TEMPLATE_SYNC_URL = 'whatsapp/templates/sync/'
export const WA_CAMPAIGNS_URL = 'whatsapp/campaigns/'
export const WA_CAMPAIGN_START_URL = (id) => `whatsapp/campaigns/${id}/start/`
export const WA_CAMPAIGN_RECIPIENTS_URL = (id) => `whatsapp/campaigns/${id}/recipients/`
export const WA_INBOX_URL = 'whatsapp/inbox/'
export const WA_CONVERSATIONS_URL = 'whatsapp/conversations/'
export const WA_OPT_IN_URL = 'whatsapp/opt-in/'
export const WA_BLACKLIST_URL = 'whatsapp/blacklist/'
export const WA_ANALYTICS_URL = 'whatsapp/analytics/'

// audit log
export const AUDIT_LOG_URL = 'audit/'

// zapier / webhook integration
export const WEBHOOK_CONFIG_URL = 'customer/webhook/config/'
export const WEBHOOK_ROTATE_URL = 'customer/webhook/rotate/'

// ERP integration
export const ERP_CONNECTION_GENERATE = 'erp/connection/generate/'
export const ERP_CONNECTION_STATUS = 'erp/connection/status/'
export const ERP_CONNECTION_REVOKE = 'erp/connection/revoke/'
// MOU — the stage between a won deal and an onboarded client
export const MOU_URL = 'mou/'
export const MOU_CONFIG_URL = 'mou/config/'
export const MOU_PREFILL_URL = (customerId) => `mou/prefill/?customer_id=${customerId}`
export const MOU_DETAIL_URL = (id) => `mou/${id}/`
export const MOU_ACTION_URL = (id) => `mou/${id}/action/`
export const MOU_EVENTS_URL = (id) => `mou/${id}/events/`
export const MOU_SHARE_LINK_URL = (id) => `mou/${id}/share-link/`
// kind: 'mou' (the document as sent) | 'signed' (the countersigned scan)
export const MOU_DOCUMENT_URL = (id, kind = 'mou') => `mou/${id}/document/?kind=${kind}`
// Public - no auth. The tenant slug travels in the path for the same reason as
// the implementation status link below: there is no JWT to resolve a tenant
// database from.
export const MOU_PUBLIC_URL = (slug, token) => `mou/public/${slug}/${token}/`
export const MOU_PUBLIC_SIGN_URL = (slug, token) => `mou/public/${slug}/${token}/sign/`
export const MOU_PUBLIC_DOCUMENT_URL = (slug, token) => `mou/public/${slug}/${token}/document/`
export const MOU_PUBLIC_OTP_URL = (slug, token) => `mou/public/${slug}/${token}/otp/`
// Documents, templates, email, reporting
export const MOU_TEMPLATES_URL = 'mou/templates/'
export const MOU_TEMPLATE_URL = (id) => `mou/templates/${id}/`
export const MOU_TEMPLATE_PREVIEW_URL = 'mou/templates/preview/'
export const MOU_APPLY_TEMPLATE_URL = (id) => `mou/${id}/apply-template/`
export const MOU_GENERATE_URL = (id, preview = false) => `mou/${id}/generate/${preview ? '?preview=1' : ''}`
export const MOU_VERSION_URL = (id, vid) => `mou/${id}/versions/${vid}/`
export const MOU_EMAIL_URL = (id) => `mou/${id}/email/`
export const MOU_DASHBOARD_URL = 'mou/dashboard/'
export const MOU_EXPORT_URL = (status = '') => `mou/export/${status ? `?status=${status}` : ''}`

// onboarded clients
export const ONBOARDED_URL = 'onboarded/'
export const ONBOARDED_DETAIL_URL = (id) => `onboarded/${id}/`
export const ONBOARDED_CONTACTS_URL = (id) => `onboarded/${id}/contacts/`
export const ONBOARDED_CONTACT_URL = (cid) => `onboarded/contacts/${cid}/`
export const ONBOARDED_AMC_URL = (id) => `onboarded/${id}/amc/`
export const ONBOARDED_AMC_DETAIL_URL = (amcId) => `onboarded/amc/${amcId}/`
export const ONBOARDED_AMC_RENEW_URL = (amcId) => `onboarded/amc/${amcId}/renew/`
export const ONBOARDED_AMC_HISTORY_URL = (amcId) => `onboarded/amc/${amcId}/history/`
export const ONBOARDED_AMC_EXPIRY_URL = 'onboarded/amc/expiring/'
export const ONBOARDED_BULK_TEMPLATE_URL = 'onboarded/bulk/template/'
export const ONBOARDED_BULK_UPLOAD_URL = 'onboarded/bulk/upload/'
export const ONBOARDED_MILESTONES_URL = (id) => `onboarded/${id}/milestones/`
export const ONBOARDED_MILESTONE_URL = (mid) => `onboarded/milestones/${mid}/`
export const ONBOARDED_MILESTONE_ACTION_URL = (mid) => `onboarded/milestones/${mid}/action/`
export const ONBOARDED_MILESTONE_EVENTS_URL = (mid) => `onboarded/milestones/${mid}/events/`
export const ONBOARDED_MILESTONE_EVENT_URL = (eid) => `onboarded/milestone-events/${eid}/`
export const ONBOARDED_STATUS_LINK_URL = (id) => `onboarded/${id}/status-link/`

// Milestone templates, plan approval, and due-date change requests
export const MILESTONE_TEMPLATES_URL = 'onboarded/templates/'
export const MILESTONE_TEMPLATE_URL = (tid) => `onboarded/templates/${tid}/`
export const ONBOARDED_SAVE_TEMPLATE_URL = (id) => `onboarded/${id}/save-as-template/`
export const ONBOARDED_APPLY_TEMPLATE_URL = (id) => `onboarded/${id}/apply-template/`
export const ONBOARDED_PLAN_URL = (id) => `onboarded/${id}/plan/`
export const ONBOARDED_PLAN_SUBMIT_URL = (id) => `onboarded/${id}/plan/submit/`
export const ONBOARDED_PLAN_DECISION_URL = (id) => `onboarded/${id}/plan/decision/`
export const MILESTONE_CHANGE_REQUEST_URL = (mid) => `onboarded/milestones/${mid}/change-request/`
export const CHANGE_REQUESTS_URL = 'onboarded/change-requests/'
export const CHANGE_REQUEST_DECISION_URL = (cid) => `onboarded/change-requests/${cid}/decision/`
export const IMPLEMENTATION_APPROVAL_CONFIG_URL = 'onboarded/approval-config/'
// Public - no auth. The tenant slug travels in the path because there is no
// JWT to resolve the tenant database from.
export const ONBOARDED_PUBLIC_STATUS_URL = (slug, token) => `onboarded/public/status/${slug}/${token}/`
export const ONBOARDED_REVENUE_REPORT = 'onboarded/reports/revenue/'
export const ONBOARDED_IMPL_REPORT = 'onboarded/reports/implementation/'
export const ONBOARDED_TICKETS_URL = (id) => `onboarded/${id}/tickets/`
export const ONBOARDED_TICKET_URL = (tid) => `onboarded/tickets/${tid}/`
export const ONBOARDED_PRODUCT_RECEIPTS_URL = (id) => `onboarded/${id}/product-receipts/`
export const ONBOARDED_PRODUCT_RECEIPT_URL = (rid) => `onboarded/product-receipts/${rid}/`
export const ONBOARDED_AMC_RECEIPTS_URL = (amcId) => `onboarded/amc/${amcId}/receipts/`
export const ONBOARDED_AMC_RECEIPT_URL = (rid) => `onboarded/amc-receipts/${rid}/`
export const ONBOARDED_NOTES_URL = (id) => `onboarded/${id}/notes/`
export const ONBOARDED_NOTE_URL = (nid) => `onboarded/notes/${nid}/`

// quotation / package master
export const QUOTATION_MODULES_URL = 'quotation/modules/'
export const QUOTATION_MODULE_URL = (id) => `quotation/modules/${id}/`
export const QUOTATION_PACKAGES_URL = 'quotation/packages/'
export const QUOTATION_PACKAGE_URL = (id) => `quotation/packages/${id}/`
export const QUOTATION_TEMPLATE_URL = 'quotation/template/'
export const QUOTATIONS_URL = 'quotation/quotations/'
export const QUOTATION_DETAIL_URL = (id) => `quotation/quotations/${id}/`
export const QUOTATION_PUBLIC_URL = (token) => `quotation/public/${token}/`
export const QUOTATION_PUBLIC_ACCEPT_URL = (token) => `quotation/public/${token}/accept/`
export const PRICING_FORMULAS_URL = 'quotation/pricing-formulas/'
export const PRICING_CALCULATOR_URL = 'quotation/pricing-calculator/'
export const PRICING_TIERS_URL = 'quotation/pricing-tiers/'
export const PLAN_SERVICES_URL = 'quotation/plan-services/'
export const PRICING_RATES_URL = 'quotation/pricing-rates/'
export const PRICING_RATES_ROWS_URL = 'quotation/pricing-rates/rows/'
export const QUOTATION_APPROVE_URL = (id) => `quotation/quotations/${id}/approve/`
export const QUOTATION_REJECT_URL = (id) => `quotation/quotations/${id}/reject/`
export const QUOTATION_VERSIONS_URL = (id) => `quotation/quotations/${id}/versions/`
// Demo-time KPIs: the hospital's revenue leak priced against one plan
export const QUOTATION_KPI_URL = (id) => `quotation/quotations/${id}/kpi/`
// Every rate and bill value the KPI screen is allowed to use. Nothing is
// hardcoded in the engine, so this is the only source of those numbers.
export const LEAK_SETTINGS_URL = 'customer/leak-settings/'
export const QUOTATION_VERSION_URL = (id, vno) => `quotation/quotations/${id}/versions/${vno}/`
export const QUOTATION_FINALIZE_URL = (id) => `quotation/quotations/${id}/finalize/`
export const QUOTATION_PDF_URL = (id) => `quotation/quotations/${id}/pdf/`
// A lead's projects with its quotations in each; several quotations as one document
export const QUOTATION_CUSTOMER_PROJECTS_URL = 'quotation/customer-projects/'
export const QUOTATION_MERGED_URL = 'quotation/merged/'


// ── Engage (Hospital CRM) endpoints ──────────────────────────────────────────
export const ENGAGE_ENQUIRIES_URL          = 'engage/enquiries/'
export const ENGAGE_ENQUIRY_URL            = (id) => `engage/enquiries/${id}/`
export const ENGAGE_ENQUIRY_CONVERT_URL    = (id) => `engage/enquiries/${id}/convert/`
export const ENGAGE_PATIENTS_URL           = 'engage/patients/'
export const ENGAGE_PATIENT_URL            = (id) => `engage/patients/${id}/`
export const ENGAGE_ACTIVITY_LOGS_URL      = 'engage/activity-logs/'
export const ENGAGE_ACTIVITY_LOG_URL       = (id) => `engage/activity-logs/${id}/`
export const ENGAGE_REFERRING_DOCTORS_URL  = 'engage/referring-doctors/'
export const ENGAGE_REFERRING_DOCTOR_URL   = (id) => `engage/referring-doctors/${id}/`
export const ENGAGE_REFERRALS_URL          = 'engage/referrals/'
export const ENGAGE_REFERRAL_URL           = (id) => `engage/referrals/${id}/`
export const ENGAGE_REFERRAL_MARK_PAID_URL = (id) => `engage/referrals/${id}/mark-paid/`
export const ENGAGE_CORPORATE_ACCOUNTS_URL = 'engage/corporate-accounts/'
export const ENGAGE_CORPORATE_ACCOUNT_URL  = (id) => `engage/corporate-accounts/${id}/`
export const ENGAGE_HEALTH_CAMPS_URL       = 'engage/health-camps/'
export const ENGAGE_HEALTH_CAMP_URL        = (id) => `engage/health-camps/${id}/`
export const ENGAGE_HEALTH_CAMP_COMPLETE_URL = (id) => `engage/health-camps/${id}/complete/`
export const ENGAGE_FOLLOWUPS_URL          = 'engage/followups/'
export const ENGAGE_FOLLOWUP_URL           = (id) => `engage/followups/${id}/`
export const ENGAGE_FOLLOWUPS_UPCOMING_URL = 'engage/followups/upcoming/'
export const ENGAGE_FOLLOWUPS_OVERDUE_URL  = 'engage/followups/overdue/'
export const ENGAGE_FOLLOWUP_COMPLETE_URL  = (id) => `engage/followups/${id}/complete/`
export const ENGAGE_FOLLOWUP_RESCHEDULE_URL = (id) => `engage/followups/${id}/reschedule/`
// Analytics
export const ENGAGE_A_REFERRER_LEADERBOARD_URL = 'engage/analytics/referrer-leaderboard/'
export const ENGAGE_A_CAMP_ROI_URL             = 'engage/analytics/camp-roi/'
export const ENGAGE_A_ENQUIRY_FUNNEL_URL       = 'engage/analytics/enquiry-funnel/'
export const ENGAGE_A_CORPORATE_RENEWALS_URL   = 'engage/analytics/corporate-renewals/'
export const ENGAGE_A_INCENTIVES_SUMMARY_URL   = 'engage/analytics/incentives-summary/'
export const ENGAGE_A_FOLLOWUP_SUMMARY_URL     = 'engage/analytics/followup-summary/'
export const ENGAGE_A_FOLLOWUP_BY_ASSIGNEE_URL = 'engage/analytics/followup-by-assignee/'

// ── Restored from ai-voice-agent-b-dup during the unify merge ───────────────
// The two branches each had constants the other lacked; api.js is the union.
export const UNIFIED_REPORT_URL = 'customer/reports/unified/'
export const PERMISSION_CATALOG_URL = 'auth/permission-catalog/'
export const AI_CALLER_DASHBOARD_URL = 'ai-caller/dashboard/'
export const AI_CALLER_CALLS_URL = 'ai-caller/calls/'
export const AI_CALLER_CALL_DETAIL_URL = (id) => `ai-caller/calls/${id}/`
export const AI_CALLER_CALL_INITIATE_URL = 'ai-caller/calls/initiate/'
export const AI_CALLER_CAMPAIGNS_URL = 'ai-caller/campaigns/'
export const AI_CALLER_CAMPAIGN_DETAIL_URL = (id) => `ai-caller/campaigns/${id}/`
export const AI_CALLER_CAMPAIGN_START_URL = (id) => `ai-caller/campaigns/${id}/start/`
export const AI_CALLER_CONFIG_URL = 'ai-caller/config/'
export const AI_CALLER_BUCKET_URL = 'ai-caller/bucket/'
export const AI_CALLER_BUCKET_ITEM_URL = (id) => `ai-caller/bucket/${id}/`
export const AI_CALLER_BUCKET_CLEAR_URL = 'ai-caller/bucket/clear/'

// ── Meta Ads ────────────────────────────────────────────────────────────────
export const META_ADS_ACCOUNTS_URL   = 'meta-ads/accounts/'
export const META_ADS_DISCOVER_URL   = 'meta-ads/accounts/discover/'
export const META_ADS_CAMPAIGNS_URL  = 'meta-ads/campaigns/'
export const META_ADS_SYNC_URL       = 'meta-ads/sync/'
export const META_ADS_SYNC_RUNS_URL  = 'meta-ads/sync/runs/'
export const AD_PERFORMANCE_REPORT_URL = 'meta-ads/reports/performance/'
export const AD_LIVE_DASHBOARD_URL     = 'meta-ads/reports/dashboard/'
export const AD_CREATIVE_REPORT_URL     = 'meta-ads/reports/creative/'
export const AD_PACING_REPORT_URL       = 'meta-ads/reports/pacing/'
export const AD_PROJECT_ROI_REPORT_URL  = 'meta-ads/reports/project-roi/'
export const AD_BREAKDOWN_REPORT_URL    = 'meta-ads/reports/breakdown/'
export const AD_ATTRIBUTION_REPORT_URL  = 'meta-ads/reports/attribution/'
export const AD_FUNNEL_REPORT_URL       = 'meta-ads/reports/funnel/'
export const AD_LEAD_QUALITY_REPORT_URL = 'meta-ads/reports/lead-quality/'
export const AD_REP_EFFECTIVENESS_URL   = 'meta-ads/reports/rep-ad/'
export const AD_TIME_LAG_REPORT_URL     = 'meta-ads/reports/time-lag/'
export const META_CONVERSION_CONFIG_URL = 'meta-ads/conversions/config/'
export const META_CONVERSION_SEND_URL   = 'meta-ads/conversions/send/'
export const META_CONVERSION_LOGS_URL   = 'meta-ads/conversions/logs/'
export const META_CONVERSION_PENDING_URL = 'meta-ads/conversions/pending/'

// Telephony — Twilio / Tata Tele Smartflo click-to-call, call log and recordings
export const TELEPHONY_CONFIG_URL     = 'telephony/config/'
export const TELEPHONY_TEST_URL       = 'telephony/config/test/'
export const TELEPHONY_ROTATE_KEY_URL = 'telephony/config/rotate-key/'
export const TELEPHONY_AGENTS_URL     = 'telephony/agents/'
export const TELEPHONY_SYNC_URL       = 'telephony/sync/'
export const TELEPHONY_CALL_URL       = 'telephony/call/'
export const TELEPHONY_CALLS_URL      = 'telephony/calls/'
export const TELEPHONY_CALL_DETAIL_URL = (id) => `telephony/calls/${id}/`
export const TELEPHONY_CALL_TRANSCRIBE_URL = (id) => `telephony/calls/${id}/transcribe/`
export const TELEPHONY_TRANSCRIBE_URL = 'telephony/transcribe/'
export const CUSTOMER_PAIN_POINTS_URL = 'customer/pain-points/'
export const PAIN_POINT_CATALOG_URL = 'customer/pain-points/catalog/'

// Release notes — admin authoring plus the login acknowledgement popup
export const RELEASES_URL             = 'releases/'
export const RELEASE_DETAIL_URL       = (id) => `releases/${id}/`
export const RELEASE_PUBLISH_URL      = (id) => `releases/${id}/publish/`
export const RELEASE_AUDIENCE_URL     = 'releases/audience/'
export const RELEASE_AUDIENCE_PREVIEW_URL = 'releases/audience-preview/'
export const RELEASES_PENDING_URL     = 'releases/pending/'
export const RELEASES_ACKNOWLEDGE_URL = 'releases/acknowledge/'

// Hospital discovery profile — fixed table, configurable per tenant
export const HOSPITAL_PROFILE_URL        = 'customer/hospital-profile/'
export const HOSPITAL_PROFILE_CONFIG_URL = 'customer/hospital-profile/config/'

// Sales-to-CRE handover — fixed table, switched on and trimmed per tenant
export const CRE_HANDOVER_URL        = 'customer/cre-handover/'
export const CRE_HANDOVER_CONFIG_URL = 'customer/cre-handover/config/'
export const STAGE_REQUIRED_FIELDS_CONFIG_URL = 'customer/stage-required-fields/config/'
export const CITY_STATE_URL = 'customer/city-state/'
export const CITY_STATE_FILL_URL = 'customer/city-state/fill/'
export const CITY_STATE_MAPPINGS_URL = 'customer/city-state/mappings/'
export const CITY_STATE_MAPPING_URL = (id) => `customer/city-state/mappings/${id}/`
export const ONBOARDED_CLIENT_LIST_REPORT_URL = 'onboarded/reports/client-list/'

// ── Outbound prospecting (trustedge prospecting/) ──────────────────────────
export const OUTBOUND_SETTINGS_URL     = 'prospecting/settings/'
export const OUTBOUND_SUMMARY_URL      = 'prospecting/summary/'
export const OUTBOUND_DISCOVER_URL     = 'prospecting/discover/'
export const OUTBOUND_PROSPECTS_URL    = 'prospecting/prospects/'
export const OUTBOUND_PROSPECT_BULK_URL = 'prospecting/prospects/bulk/'
export const outboundProspectUrl       = (id) => `prospecting/prospects/${id}/`
export const OUTBOUND_COHORTS_URL      = 'prospecting/cohorts/'
export const OUTBOUND_SEQUENCES_URL    = 'prospecting/sequences/'
export const outboundSequenceUrl       = (id) => `prospecting/sequences/${id}/`
export const outboundSequenceEnrollUrl = (id) => `prospecting/sequences/${id}/enroll/`
export const OUTBOUND_OUTBOX_URL       = 'prospecting/outbox/'
export const OUTBOUND_OUTBOX_ACTION_URL = 'prospecting/outbox/action/'
export const outboundOutboxItemUrl     = (id) => `prospecting/outbox/${id}/`
export const OUTBOUND_REPLIES_URL      = 'prospecting/replies/'
export const outboundReplyIntentUrl    = (id) => `prospecting/replies/${id}/intent/`
export const OUTBOUND_SUPPRESSIONS_URL = 'prospecting/suppressions/'

// Company research agent (trustedge research/). Jobs run in the local AI worker.
export const RESEARCH_LEAD_URL     = (customerId) => `research/lead/${customerId}/`
export const RESEARCH_SUMMARY_URL  = (customerId) => `research/lead/${customerId}/summary/`
export const RESEARCH_START_URL    = (customerId) => `research/lead/${customerId}/start/`
export const RESEARCH_JOB_URL      = (jobId) => `research/jobs/${jobId}/`
export const RESEARCH_CANCEL_URL   = (jobId) => `research/jobs/${jobId}/cancel/`
export const RESEARCH_IDENTITY_URL = (jobId) => `research/jobs/${jobId}/identity/`
export const RESEARCH_REVIEW_URL   = (jobId) => `research/jobs/${jobId}/review/`
export const RESEARCH_SETTINGS_URL = 'research/settings/'

// Sales Manager Agent (trustedge sales_agent/). AI narratives come from the local AI worker.
export const SALES_AGENT_OVERVIEW_URL  = 'sales-agent/overview/'
export const SALES_AGENT_KPIS_URL      = 'sales-agent/kpis/'
export const SALES_AGENT_ALERTS_URL    = 'sales-agent/alerts/'
export const SALES_AGENT_ALERT_ACTION_URL = (id) => `sales-agent/alerts/${id}/action/`
export const SALES_AGENT_ALERTS_BULK_URL  = 'sales-agent/alerts/bulk/'
export const SALES_AGENT_BRIEFINGS_URL = 'sales-agent/briefings/'
export const SALES_AGENT_BRIEFING_URL  = (id) => `sales-agent/briefings/${id}/`
export const SALES_AGENT_GENERATE_URL  = 'sales-agent/briefings/generate/'
export const SALES_AGENT_SETTINGS_URL  = 'sales-agent/settings/'
export const SALES_AGENT_DIGEST_URL    = 'sales-agent/digest/'
export const SALES_AGENT_DIGEST_PREVIEW_URL = 'sales-agent/digest/preview/'
export const SALES_AGENT_DIGEST_TEST_URL    = 'sales-agent/digest/test/'
